export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: false,
  caisseApiUrl: 'https://caisse-backend.localhost/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-01T10:29:40",
  lastPipeline: "6457",
  version: "0.0.0",
  sentryDsn: '',
};
